import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Careers from "@/pages/Careers";
import Resources from "@/pages/Resources";
import Onboarding from "@/pages/Onboarding";
import PortalLogin from "@/pages/PortalLogin";
import Portal from "@/pages/Portal";

function MarketingLayout({ children }) {
  return (
    <div className="wcc-noise relative overflow-x-hidden">
      <Navbar />
      {children}
      <Footer />
    </div>
  );
}

function AppRoutes() {
  const loc = useLocation();
  const bare = ["/onboarding", "/portal", "/portal/login"].some((p) => loc.pathname.startsWith(p));
  return (
    <>
      {!bare && <SmoothScroll />}
      <Routes>
        <Route path="/" element={<MarketingLayout><Home /></MarketingLayout>} />
        <Route path="/careers" element={<MarketingLayout><Careers /></MarketingLayout>} />
        <Route path="/resources" element={<MarketingLayout><Resources /></MarketingLayout>} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/portal/login" element={<PortalLogin />} />
        <Route path="/portal" element={<Portal />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-center" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
